import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsPurchasesType extends Component{ 

    constructor(props){
      super(props);

      this.state={
          purchasetypes:[],
          modalTitle:"",
          purchasetypename:"",
          purchasetypeid:0,

          PurchaseTypeIdFilter:"",
          PurchaseTypeNameFilter:"",
          purchasetypesWithoutFilter:[],
          purchasetypeNames: [],
          purchasetypeExists: false, 
      }
  }

  FilterFn(){
    var PurchaseTypeIdFilter=this.state.PurchaseTypeIdFilter;
    var PurchaseTypeNameFilter = this.state.PurchaseTypeNameFilter;

    var filteredData=this.state.purchasetypesWithoutFilter.filter(
        function(el){
            return el.purchasetypeid.toString().toLowerCase().includes(
                PurchaseTypeIdFilter.toString().trim().toLowerCase()
            )&&
            el.purchasetypename.toString().toLowerCase().includes(
                PurchaseTypeNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({purchasetypes:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.purchasetypesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({purchasetypes:sortedData});

}

changePurchaseTypeIdFilter = (e)=>{
  this.state.PurchaseTypeIdFilter=e.target.value;
  this.FilterFn();
}
changePurchaseTypeNameFilter = (e)=>{
  this.state.PurchaseTypeNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/purchasetypes/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({purchasetypes:data,purchasetypesWithoutFilter:data});
  });
}


fetchPurchaseTypeNames() {
  axiosService.get('/purchasetypes/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const purchasetypeNames = data.map(item => item.purchasetypename);
      this.setState({ purchasetypeNames: purchasetypeNames });
    })
    .catch(error => {
      console.error("Error fetching purchasetype names:", error);
    });
}

checkPurchaseTypeExists = (event) => {
  const enteredPurchaseType = event.target.value.toLowerCase(); // Convert to lowercase
  const { purchasetypeNames } = this.state;
  const purchasetypeExists = purchasetypeNames.some((purchasetype) => purchasetype.toLowerCase() === enteredPurchaseType);
  this.setState({ purchasetypeExists });
};


componentDidMount(){
  this.refreshList();
  this.fetchPurchaseTypeNames();
}

changePurchaseTypeName =(e)=>{
  this.setState({purchasetypename:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add PurchaseType",
      purchasetypeid:0,
      purchasetypename: "",
      purchasetypeExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit PurchaseType",
      purchasetypeid:dep.purchasetypeid,
      purchasetypename:dep.purchasetypename,
      initialPurchasetypename:dep.purchasetypename,
      purchasetypeExists: false,
  });
}

createClick() {
  const { purchasetypename, purchasetypeNames } = this.state;

  if (!purchasetypename) {
    alert('Purchase Type Name is required');
    return;
  }

  if (purchasetypeNames.some(name => name.toLowerCase() === purchasetypename.toLowerCase())) {
    alert('PurchaseType already exists. Please provide a unique PurchaseType Name.');
    return;
  }

  axiosService.post('/purchasetypes/', {
    purchasetypename: purchasetypename
  })
    .then(result => {
      alert('PurchaseType created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { purchasetypename, initialPurchasetypename, purchasetypeNames } = this.state;

   // Check if any changes are detected
   if (
    purchasetypename === initialPurchasetypename
  ) {
    alert('No changes detected');
    return;
  }

  if (
    purchasetypeNames.some(
      (existingPurchaseType) =>
        existingPurchaseType.toLowerCase() === purchasetypename.toLowerCase()
    )
  ) {
    alert('PurchaseType already exists. Please provide a unique PurchaseType Name.');
    return;
  }

  if (!purchasetypename) {
    alert('Purchase Type Name is required');
    return;
  }

  axiosService.patch('/purchasetypes/'+id+'/',{
      purchasetypeid:this.state.purchasetypeid,
      purchasetypename:this.state.purchasetypename
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/purchasetypes/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      purchasetypes,
      modalTitle,
      purchasetypeid,
      purchasetypename,
      purchasetypeExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePurchaseTypeIdFilter}
      placeholder="Filter"/>
      
      </div>
      PurchaseTypeId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePurchaseTypeNameFilter}
      placeholder="Filter"/>

      </div>
      PurchaseType

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {purchasetypes.map(dep=>
      <tr key={dep.purchasetypeid} className="row-hover">
          <td className="table-text">{dep.purchasetypeid}</td>
          <td className="table-text">{dep.purchasetypename}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>


          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PurchaseType</span>
          <input
            type="text"
            className={`form-control ${purchasetypeExists ? "is-invalid" : ""}`}
            value={purchasetypename}
            onChange={this.changePurchaseTypeName}
            onBlur={this.checkPurchaseTypeExists} 
            style={{ fontSize: "12px" }} 
          />
          {purchasetypeExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >PurchaseType already exists.</div>}
        </div>

        {purchasetypeid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {purchasetypeid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(purchasetypeid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

